<template>
  <div class="container-fluid p-0">
    <div class="w-100 general-header">
        <p class="text-center pt-1 pb-1 m-0">Recogida de contenedor vacío</p>
     </div>
     <div class="w-100 layout-selected-pickup">
        <div class="form-group">
            <label for="nombre">Selección de {{type}}</label>
            <select class="select-input mt-2 " v-if="type=='transportista'" v-model="selectedTransport">
                <option  v-for="(transportista, index) in transportistas" :key="index" >{{transportista}}</option>
            </select>
            <select class="select-input mt-2 " v-if="type=='cargador'">
                <option  v-for="(cargador, index) in cargadores" :key="index" >{{cargador}}</option>
            </select>
            <select class="select-input mt-2 " v-if="type=='consignatario'">
                <option  v-for="(consignatario, index) in consignatarios" :key="index" >{{consignatario}}</option>
            </select>
        </div>
     </div>
     <div class="layout-more-actions" v-bind:class="{ 'hide': type!='transportista'}">
        <label class="d-block mb-2 mt-2">Más acciones</label>
        <router-link tag="a" to = '' class="d-block  pt-3 link-1 w-100" >Gestionar transportistas</router-link>
        <router-link tag="a" to = '' class="d-block  pt-2  link-1 w-100" >Registro de nuevo transportista</router-link>
     </div>
     <div class="layout-selected-pickup">
        <div class="form-group mt-4">
            <button type="submit" class="btn-general" @click="selectTransportista()">
                ASOCIAR Y AVISAR PARA RECOGIDA
            </button>
        </div>
     </div>
     <confirmModal v-if="modalVisible" message="Transportista notificado para recogida"></confirmModal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getData, setData, putData, updateAction } from '@/services/api'
import confirmModal from '@/components/confirmModal'

export default {
    name: 'EmptyContainer',
    components: { confirmModal },
    props: {
        type: String,
    },
    data() {
        return {
            transportistas: ['OLC', 'Transportista 1', 'Transportista 2'],
            selectedTransport: 'OLC',
            cargadores: ['Cargador 1', 'Cargador 2'],
            consignatarios: ['Consignatario 1', 'Consignatario 2'],

            modalVisible: false
        }
    },
    computed: { 
    ...mapGetters("container",{
      container_id: 'container_id',
      actions: 'action_list'
    }),  
  },
    mounted () {
        this.$store.commit('set_view_name', ['Nuevo expediente'])
    },
    methods: {
        selectTransportista() {
            if(this.type == 'transportista'){
                getData('expedientes/' + this.container_id).then(res => {
                    var container_data = res.data

                    // API - Assign "Transportista" to expedient
                    container_data["transportista"] = {
                        "name": this.selectedTransport
                    }
                    setData('expedientes/', container_data)

                    // Change expedient state in backend
                    var now = new Date(); 
                    updateAction(this.container_id, "AVISO_A_TRANSPORTISTA", now, this.actions.stage2.action_list.action004.apiId)
                    updateAction(this.container_id, "ORDEN_DE_RECOGIDA", "pending", '')

                    this.modalVisible = true
                }) 
            }
        }
    }
}
</script>

<style lang= "scss"  scoped>


</style>
